import React, { useContext, useRef } from 'react';
import clsx from 'clsx';
import Depot from '../../../_shared/depot';
import { DeviceManagerContext } from '@trainline-shareable/device-manager';
import * as styles from './style.module.css';
const Inset = ({ children, className, insetTop = false, insetBottom = false, ...commonProps }) => {
    const insetContentClasses = clsx(styles.insetContentContainer, {
        [styles.insetTop]: insetTop,
        [styles.insetBottom]: insetBottom,
    });
    return Depot.createElement('div', {
        className: insetContentClasses,
        ...commonProps,
    }, React.createElement(React.Fragment, null, children));
};
export const ContentWithoutRef = ({ children, className, isFlush = false, ...commonProps }) => {
    // Contexts
    const deviceManager = useContext(DeviceManagerContext);
    // Derived values
    const isMobileViewport = /(X?S)/.test((deviceManager === null || deviceManager === void 0 ? void 0 : deviceManager.viewPort) || 'S');
    // Classes
    const modalClasses = clsx(styles.contentContainer, {
        [styles.desktopModal]: !isMobileViewport,
        [styles.mobileModal]: isMobileViewport,
    });
    const headerShadowCoverClasses = clsx(styles.headerShadowCover);
    const footerShadowCoverClasses = clsx(styles.footerShadowCover);
    const contentChildrenClasses = clsx(styles.contentWrapper, {
        [styles.desktopModal]: !isMobileViewport,
        [styles.isFlush]: isFlush,
    });
    // Refs
    const contentRef = useRef(null);
    return Depot.createElement('div', {
        className: modalClasses,
        ...commonProps,
    }, React.createElement(React.Fragment, null,
        isMobileViewport && React.createElement("div", { className: headerShadowCoverClasses }),
        React.createElement("div", { className: contentChildrenClasses, ref: contentRef }, children),
        isMobileViewport && React.createElement("div", { className: footerShadowCoverClasses })));
};
const InsetWithRef = Depot.withRef(Inset);
ContentWithoutRef.Inset = InsetWithRef;
const ContentSubComponents = {
    Inset: InsetWithRef,
};
const Content = Depot.withRef(ContentWithoutRef, ContentSubComponents);
Content.displayName = 'Content';
export default Content;
//# sourceMappingURL=index.js.map